import { syncAdPixels } from "@/lib/ad-pixels";
import { initGoogleAnalytics, isLiveHost } from "@/lib/analytics-init";
import {
  applyConsentUpdate,
  CONSENT_GRANTED_EVENT,
  setStoredConsent,
} from "@/lib/consent";
import type { ConsentChoice } from "@/lib/consent";

/** Applies a fresh banner choice in the order required by Consent Mode:
 * store it, establish denied defaults on a live host, then queue the update. */
export function commitFreshConsentChoice(choice: ConsentChoice): void {
  setStoredConsent(choice);
  if (typeof window !== "undefined" && isLiveHost(window.location.hostname)) {
    initGoogleAnalytics();
  }
  applyConsentUpdate(choice);
  // Advertising tags follow the stored choice: loaded on a grant, revoked and removed on a refusal.
  syncAdPixels();
  if (choice === "granted" && typeof window !== "undefined") {
    window.dispatchEvent(new Event(CONSENT_GRANTED_EVENT));
  }
}
